import SvgIcon from '@material-ui/core/SvgIcon';

const SIZE_MAP = {
  small: 32,
  medium: 40,
  large: 48,
};

const WarningTriangleIcon = ({
  fillColor,
  className,
  size = 'medium',
}: {
  fillColor?: string;
  className?: string;
  size?: 'small' | 'medium' | 'large';
}) => {
  return (
    <SvgIcon
      className={className}
      style={{ fontSize: SIZE_MAP[size] }}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.63332 28C3.38887 28 3.16665 27.9389 2.96665 27.8167C2.76665 27.6944 2.6111 27.5333 2.49998 27.3333C2.38887 27.1333 2.32776 26.9167 2.31665 26.6833C2.30554 26.45 2.36665 26.2222 2.49998 26L14.8333 4.66667C14.9667 4.44444 15.1389 4.27778 15.35 4.16667C15.5611 4.05556 15.7778 4 16 4C16.2222 4 16.4389 4.05556 16.65 4.16667C16.8611 4.27778 17.0333 4.44444 17.1667 4.66667L29.5 26C29.6333 26.2222 29.6944 26.45 29.6833 26.6833C29.6722 26.9167 29.6111 27.1333 29.5 27.3333C29.3889 27.5333 29.2333 27.6944 29.0333 27.8167C28.8333 27.9389 28.6111 28 28.3667 28H3.63332ZM16 24C16.3778 24 16.6944 23.8722 16.95 23.6167C17.2055 23.3611 17.3333 23.0444 17.3333 22.6667C17.3333 22.2889 17.2055 21.9722 16.95 21.7167C16.6944 21.4611 16.3778 21.3333 16 21.3333C15.6222 21.3333 15.3055 21.4611 15.05 21.7167C14.7944 21.9722 14.6667 22.2889 14.6667 22.6667C14.6667 23.0444 14.7944 23.3611 15.05 23.6167C15.3055 23.8722 15.6222 24 16 24ZM16 20C16.3778 20 16.6944 19.8722 16.95 19.6167C17.2055 19.3611 17.3333 19.0444 17.3333 18.6667V14.6667C17.3333 14.2889 17.2055 13.9722 16.95 13.7167C16.6944 13.4611 16.3778 13.3333 16 13.3333C15.6222 13.3333 15.3055 13.4611 15.05 13.7167C14.7944 13.9722 14.6667 14.2889 14.6667 14.6667V18.6667C14.6667 19.0444 14.7944 19.3611 15.05 19.6167C15.3055 19.8722 15.6222 20 16 20Z"
        fill={fillColor || '#FF543E'}
      />
      <path
        d="M16 24C16.3778 24 16.6944 23.8722 16.95 23.6167C17.2055 23.3611 17.3333 23.0444 17.3333 22.6667C17.3333 22.2889 17.2055 21.9722 16.95 21.7167C16.6944 21.4611 16.3778 21.3333 16 21.3333C15.6222 21.3333 15.3055 21.4611 15.05 21.7167C14.7944 21.9722 14.6667 22.2889 14.6667 22.6667C14.6667 23.0444 14.7944 23.3611 15.05 23.6167C15.3055 23.8722 15.6222 24 16 24ZM16 20C16.3778 20 16.6944 19.8722 16.95 19.6167C17.2055 19.3611 17.3333 19.0444 17.3333 18.6667V14.6667C17.3333 14.2889 17.2055 13.9722 16.95 13.7167C16.6944 13.4611 16.3778 13.3333 16 13.3333C15.6222 13.3333 15.3055 13.4611 15.05 13.7167C14.7944 13.9722 14.6667 14.2889 14.6667 14.6667V18.6667C14.6667 19.0444 14.7944 19.3611 15.05 19.6167C15.3055 19.8722 15.6222 20 16 20Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default WarningTriangleIcon;
